import styled from "styled-components";

export const FooterStyles = styled.div`

ul {
    list-style-type: none;
    display: flex;
    justify-content: center;
}

li {
    margin: 0 0.5rem ;
    list-style-type: none;
    &:hover {
    color: var(--yellow);
    cursor: pointer;
    } 
}

svg{
    font-size:1.5rem;
    margin-right: 1rem;
    }  
`
